import type { Schema } from '@/shared/api/contract';
import type { EmailCategory } from '@/shared/triage/vocabulary';

/** Straight from the contract: cubas.domain.schemas.triage. */
export type TriageActivation = Schema<'TriageActivation'>;
export type ModeEntry = Schema<'ModeEntry'>;

/** The mode entries grouped by mailbox and keyed by category, mailboxes sorted. */
export function modesByMailbox(entries: ModeEntry[]): Map<string, Map<EmailCategory, ModeEntry>> {
  const grouped = new Map<string, Map<EmailCategory, ModeEntry>>();
  for (const entry of entries) {
    const rows = grouped.get(entry.mailbox) ?? new Map<EmailCategory, ModeEntry>();
    rows.set(entry.category, entry);
    grouped.set(entry.mailbox, rows);
  }
  return new Map([...grouped].sort(([a], [b]) => a.localeCompare(b)));
}
